import { useContext, useEffect, useState } from 'react';

import { getCrossConnections } from '../../api';
import { SettingsContext } from './context';
import { PlatformSettingsProps } from './types';

export const usePlatformSettings = (
  loginProjectId?: string,
  getNewData: boolean = true
): PlatformSettingsProps => {
  // ToDo: finish this hook
  const { platformSettings, setPlatformSettings } = useContext(SettingsContext);
  const [fetching, setFetching] = useState<boolean>(true);

  useEffect(() => {
    if (!getNewData || !loginProjectId) {
      return;
    }
    getCrossConnections(loginProjectId).then((res) => {
      setFetching(false);
      setPlatformSettings(res);
    });
  }, [loginProjectId, getNewData]);

  const havePlatformConnect = () => {
    if (!platformSettings) {
      return false;
    }

    const connectedSocials = platformSettings.filter((platform) => platform.connected);
    return connectedSocials.length !== 0;
  };

  return {
    platformSettingsFetching: fetching,
    platformSettings,
    setPlatformSettings,
    havePlatformConnect
  };
};
